import { hide, show } from '@fnv-core/dom';
import { IPlugin, PluginManager } from '@fnv-static/plugins';

const PLUGIN_SELECTOR = '.js-show-on-click';

class ShowOnClickPlugin implements IPlugin {
  constructor(private _element: HTMLElement) {}

  init() {
    const elementsToShowSelector = this._element.getAttribute('data-show-on-click-target');

    // Initially hide all
    document.querySelectorAll<HTMLElement>(elementsToShowSelector).forEach(elem => {
      hide(elem);
    });

    this._element.addEventListener('click', () => {
      const elementsToShow = document.querySelectorAll<HTMLElement>(elementsToShowSelector);
      
      if (!elementsToShow?.length) {
        return;
      }
      elementsToShow.forEach(element => {
        show(element);
      });

      hide(this._element);
    });
  }
}

export function initShowOnClick() {
  const elements = document.querySelectorAll<HTMLElement>(PLUGIN_SELECTOR);
  elements.forEach(element => {
    new ShowOnClickPlugin(element).init();
  });
}

PluginManager.registerPlugin('show-on-click', initShowOnClick);
